<template>
    <div class="container">
        <van-nav-bar leftText leftArrow @click-left="backGo" title="银行卡详情" class="headerbar">
            <van-button
                slot="right"
                class="btn btn-text"
                v-if="isDel"
                @click="showDialog('isDialog')"
            >
                <div class="ico-adds bg-100"></div>
            </van-button>
        </van-nav-bar>
        <div class="topbar-container">
            <div class="bankList-list">
                <div class="bankList-list-item">
                    <div class="item bh bstart bg_100" :style="{'backgroundColor': item.backColor}">
                        <div
                            class="bigIco bg-contain"
                            :style="{backgroundImage: `url('${item.bankBigIcon}')`}"
                        ></div>
                        <div class="bv bankcontent">
                            <div class="bh bstart">
                                <div class="ico-box">
                                    <div
                                        class="bg-100 ico"
                                        :style="{backgroundImage: `url('${item.bankIcon}')`}"
                                    ></div>
                                </div>
                                <div class="name fz_40 c_white">{{item.bankName}}</div>
                            </div>
                            <div class="b1">
                                <div class="bankListNum fz_60 c_white bh bstart">
                                    <div class="num bh bstart">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </div>
                                    <div class="num bh bstart">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </div>
                                    <div class="num bh bstart">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </div>
                                    <div class="num">{{item.bankNo}}</div>
                                </div>
                            </div>
                        </div>

                        <div class="btn-container" @click.stop="onEditClick(item.id)">
                            <div class="bg-contain ico-edit"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="!isDel" class="message bh bstart c_666 fz_28 border-bottom">
                <div class="ico-warning bg-contain"></div>仅剩一张银行卡，不可解绑
            </div>
        </div>
        <van-action-sheet
            v-model="isDialog"
            :actions="actions"
            @select="onSelect"
            cancel-text="取消"
        />
    </div>
</template>

<script>
import { user } from "@/mixin/user";
import { routeCache } from "@/mixin/cache";
import { mixinDialog } from "@/mixin/dialog";
import { bankDel } from "@/api/money";
export default {
    mixins: [user, routeCache, mixinDialog],
    name: "UserBankInfo",
    data() {
        return {
            isDel: false,
            item: {},
            actions: [{ name: "解除绑定" }]
        };
    },
    methods: {
        userLoginend() {
            const me = this,
                data = me.getCache();
            me.item = data.item;
            me.isDel = data.length > 1;
        },
        // 解绑
        onSelect(item) {
            const me = this;
            me.dialog
                .confirm(
                    {
                        title: "提示",
                        message:
                            "解除绑定后相关服务将不可使用，确定要解除绑定该银行卡吗？"
                    },
                    true
                )
                .then(() => {
                    bankDel(me.item).then(() => {
                        me.$store.dispatch("money/bankList", true);
                        me.$store.dispatch("money/verificationInfo", true);
                        me.backGo();
                    });
                })
                .catch(() => {
                    me.hiddenDialog();
                });
        }
    }
};
</script>

<style scoped lang="scss">
@include ico-list("~@/assets/imges/ico/", "adds");
.container {
    background-color: #f1f2f3;
}
.btn-text{
    padding-top: 26px;
}
/deep/.van-icon {
    width: 50px;
    height: 50px;
    font-size:28px;
}
.icon-btn{
    font-size:30px;
}
.ico-adds{
    width: 36px;
    height: 36px;
}
.bankList-list {
    padding: 24px 30px 0 30px;
    .bankList-list-item {
        padding-bottom: 24px;
        .item {
            @include border-radius(12px);
            position: relative;
            .bigIco {
                width: 240px;
                height: 240px;
                position: absolute;
                top: 40px;
                right: 30px;
                bottom: 20px;
            }
            .bankcontent {
                padding: 40px 20px 0px 37px;
                .ico-box {
                    @include border-radius(50%);
                    width: 66px;
                    height: 66px;
                    line-height: 60px;
                    background-color: #ffffff;
                    opacity: 0.7;
                    .ico {
                        width: 50px;
                        height: 50px;
                        margin: 8px 8px;
                    }
                }
                .name {
                    padding-left: 10px;
                }
                .bankListNum {
                    //    padding-left: 32px;
                    padding: 94px 0 46px 32px;
                    .num {
                        padding-left: 25px;
                        span {
                            @include border-radius(50%);
                            display: block;
                            width: 16px;
                            height: 16px;
                            background-color: #ffffff;
                            margin-left: 10px;
                        }
                    }
                }
            }
        }
    }
}
.message {
    padding: 0 30px;
    .ico-warning {
        width: 34px;
        height: 34px;
        margin: 3px 12px 0 0;
    }
}
</style>